import React from 'react'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

const articles = new Map([
	['loans-cс', dynamic(() => import('screens/faq/articles/LoanCC'))],
	['about-сс', dynamic(() => import('screens/faq/articles/AboutCC'))],
	['loan-conditions', dynamic(() => import('screens/faq/articles/LoanConditions'))],
	['contract-and-money', dynamic(() => import('screens/faq/articles/ContractAndMoney'))],
	['loan-repayments', dynamic(() => import('screens/faq/articles/LoanRepayments'))],
	['invest-cс', dynamic(() => import('screens/faq/articles/InvestCC'))],
	['company-сс', dynamic(() => import('screens/faq/articles/CompanyCC'))],
	['safety', dynamic(() => import('screens/faq/articles/Safety'))],
	['contract-and-deposit', dynamic(() => import('screens/faq/articles/ContractAndDeposit'))],
	['actions', dynamic(() => import('screens/faq/articles/Actions'))],
])

const Article = () => {
	const { query } = useRouter()

	const key = query.slug?.toString()
	const Component = key && articles.get(key)

	if (Component) {
		return (
			<main>
				<Component key={key} />
			</main>
		)
	}

	return null
}

export default Article
